// import React, { useEffect, useRef, useState } from "react";
// import { useReactToPrint } from "react-to-print";
// import ThermalInvoice from "./ThermalInvoice";
// import Barcode from "react-barcode";
// import products from "../../../../Data/products.json";
// import inventory from "../../../../Data/inventory.json";
// import { PrinterOutlined } from "@ant-design/icons";
// import { useParams } from "react-router-dom";
// import { get_invoice } from "../../../../Controllers/Sales/Invoices";
// import toast from "react-hot-toast";
// import InvoiceA5 from "./a5Invoice";
// import { Button } from "antd";
// import Header from "../../../../Componets/Header";
// import A4Invoice from "./a4nvoice";

// const BillingView = (props) => {
//   let { id } = useParams();

//   const invoiceRef = useRef();
//   const invoiceA4Ref = useRef();
//   const invoiceA5Ref = useRef();

//   const handlePrint = useReactToPrint({
//     content: () => invoiceRef.current,
//   });

//   const handleA4Print = useReactToPrint({
//     content: () => invoiceA4Ref.current,
//   });

//   const handleA5Print = useReactToPrint({
//     content: () => invoiceA5Ref.current,
//   });

//   const [loader, setLoader] = useState(false);
//   const [values, setValues] = useState();

//   const handleData = (invoice) => {
//     setValues(invoice);
//     setLoader(false);
//   };

//   const fetchData = async () => {
//     if (id) {
//       setLoader(true);

//       const data = {
//         id: id,
//       };

//       const invoice = await get_invoice(data);
//       if (invoice?.status) {
//         handleData(invoice?.data);
//         console.log(invoice?.data, "invoice?.datainvoice?.datainvoice?.data");
//       } else {
//         toast?.error(invoice?.message);
//       }
//     } else {
//       setLoader(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   return (
//     <div>
//       <Header />
//       <div className="">
//         <div className="pb-8">
//           <div className="flex justify-end">
//             <div className="pt-2 " onClick={handlePrint}>
//               <Button size="large">
//                 Thermal Print <PrinterOutlined className="text-lg" />
//               </Button>
//             </div>
//             <div className="p-2" onClick={handleA4Print}>
//               <Button size="large">
//                 A4 Print <PrinterOutlined className="text-lg" />
//               </Button>
//             </div>
//             <div className="p-2" onClick={handleA5Print}>
//               <Button size="large">
//                 A5 Print <PrinterOutlined className="text-lg" />
//               </Button>
//             </div>
//           </div>
//         </div>

//         <div className="hidden-on-screen">
//           <ThermalInvoice ref={invoiceRef} values={values} />
//         </div>

//         <div>
//           <A4Invoice ref={invoiceA4Ref} values={values} />
//         </div>

//         <div className="hidden-on-screen">
//           <InvoiceA5 ref={invoiceA5Ref} values={values} />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BillingView;

import React, { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import A4Invoice from "./a4nvoice";
import ThermalInvoice from "./ThermalInvoice";
import Barcode from "react-barcode";
import { PrinterOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import InvoiceA5 from "./a5Invoice";
import { Button } from "antd";
import { get_invoice } from "../../../../Controllers/Sales/Invoices";
import Header from "../../../../Componets/Header";
import headers from "../../../../Data/Forms/Billings/Billings/headers";
import Loadercomponent from "../../../../Componets/Loader";
import InvoiceA5Header from "./a5InvoiceHeader";
import ScrollWrapper from "../../../../Componets/ScrollWrapper";

const BillingView = (props) => {
  let { id } = useParams();

  const invoiceA4Ref = useRef();
  const invoiceRef = useRef();
  const invoiceA5Ref = useRef();
  const invoiceA5HeaderRef = useRef();

  const handleA4Print = useReactToPrint({
    content: () => invoiceA4Ref.current,
  });

  const handlePrint = useReactToPrint({
    content: () => invoiceRef.current,
  });

  const handleA5Print = useReactToPrint({
    content: () => invoiceA5Ref.current,
  });
  const handleA5HeaderPrint = useReactToPrint({
    content: () => invoiceA5HeaderRef.current,
  });

  const [loader, setLoader] = useState(false);
  const [values, setValues] = useState();
  const [header, setHeader] = useState(headers);

  const handleData = (invoice) => {
    const modifiedDetails = invoice.details.map((item) => ({
      ...item,
      tax: item.tax?.rate ?? null,
    }));

    const updatedInvoice = { ...invoice, details: modifiedDetails };

    setValues(updatedInvoice);
    setLoader(false);
  };


  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const invoice = await get_invoice(data);

      if (invoice?.status) {
        handleData(invoice?.data);
      } else {
        toast?.error(invoice?.message);
      }
    } else {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} >
      <Loadercomponent loader={loader}>
        <ScrollWrapper>
          <div className="pb-8">
            <div className="flex justify-end">
              <div className="p-2" onClick={handleA4Print}>
                <Button size="large">
                  A4 Print <PrinterOutlined className="text-lg" />
                </Button>
              </div>
              <div className="pt-2 " onClick={handlePrint}>
                <Button size="large">
                  Thermal Print <PrinterOutlined className="text-lg" />
                </Button>
              </div>
              <div className="p-2" onClick={handleA5Print}>
                <Button size="large">
                  A5 Print <PrinterOutlined className="text-lg" />
                </Button>
              </div>
              <div className="p-2" onClick={handleA5HeaderPrint}>
                <Button size="large">
                  A5 Header Print <PrinterOutlined className="text-lg" />
                </Button>
              </div>
            </div>
          </div>
          {/* <div className="flex float-right">
          <div className="p-2" onClick={handleA4Print}>
            <Button size="large">
              A4 Print <PrinterOutlined className="text-lg" />
            </Button>
          </div>
          <div className="pt-2 " onClick={handlePrint}>
            <Button size="large">
              Thermal Print <PrinterOutlined className="text-lg" />
            </Button>
          </div>
          <div className="p-2" onClick={handleA5Print}>
            <Button size="large">
              A5 Print <PrinterOutlined className="text-lg" />
            </Button>
          </div>
        </div> */}

          <div>
            <A4Invoice ref={invoiceA4Ref} values={values} />
          </div>

          <div className="hidden-on-screen">
            <ThermalInvoice ref={invoiceRef} values={values} />
          </div>

          <div className="hidden-on-screen">
            <InvoiceA5 ref={invoiceA5Ref} values={values} />
          </div>

          <div className="hidden-on-screen">
            {/* <InvoiceA5 ref={invoiceA5Ref} values={values} /> */}
            <InvoiceA5Header ref={invoiceA5HeaderRef} values={values} />
          </div>
        </ScrollWrapper>
      </Loadercomponent>
    </Header>
  );
};

export default BillingView;
